import {
  //TYPES
  MAP_UTILITIES_SELECT_MODULE,
  MAP_UTILITIES_SHOW_MAP_SETTINGS,
  MAP_UTILITIES_SHOW_TAG_APPLIES
} from 'Redux/actionTypes';

export const selectModuleMapSettings = (currentModule) => {
  return {
    type: MAP_UTILITIES_SELECT_MODULE,
    payload: { currentModule }
  };
}

export const setShowMapSettings = (showMapSettings) => {
  return {
    type: MAP_UTILITIES_SHOW_MAP_SETTINGS,
    payload: { showMapSettings }
  };
}

export const setShowTagFIlterApplied = (showMapSettings = false) => {
  return {
    type: MAP_UTILITIES_SHOW_TAG_APPLIES,
    payload: { showTagFilterApplied: showMapSettings }
  };
}